import { useEffect, useRef, useState } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import DeleteConfirmation from "application/components/DeleteConfirmation";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import CTLNotification from "application/components/CTLNotification";
import MDButton from "components/MDButton";
import { Box, Dialog, DialogActions, DialogContent } from "@mui/material";
import MDTypography from "components/MDTypography";

function DiscoveredIP({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, darkMode } = controller;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [updateList, setUpdateList] = useState(Date.now());
  const [openSelect, setOpenSelect] = useState(false);

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const selectedRowsRef = useRef([]);

  useEffect(() => {
    const ipAddresses = selectedRowData.map((item) => item.ipAddress);
    selectedRowsRef.current = ipAddresses;
  }, [selectedRowData]);

  function GetDropdownData() {
    application
      .post("categoryService/dropdownCategoryCode/list")
      .then((response) => {
        const categories = Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setCategoryOptions(categories);
      })
      .catch((error) => {
        console.error("Failed to load category dropdown", error);
        setCategoryOptions([]);
      });
  }
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        openForm: onOpenForm,
        onNoDefaultComparison: onNoDefaultComparison,
        MultipleUpdate: onOpenMultiUpdate,
        onRefresh:onRefresh
      });
  }, [activePage]);

  const onRefresh = () => {
    setUpdateList(Date.now);
  };

  function onNoDefaultComparison() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: pageName,
      });
      return;
    }
    setOpenSelect(true);
    GetDropdownData();
  }

  function onOpenMultiUpdate() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: pageName,
      });
      return;
    }
    const data = {
      ipList: selectedRowsRef.current,
    };
    application
      .post("/discoverIp/update", data)
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: pageName,
        });
      });
  }

  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onOpenForm() {
    setFormData({
      eventTime: Date.now(),
    });
    setOpenForm(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }

  function onApplyFilter(advancedFilters) {
    setAdvancedFilters(advancedFilters);
    setOpenFilter(false);
  }

  const deleteRow = (row) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  const editRow = (row) => {
    setFormData(row);
    setOpenForm(true);
  };

  const onAgree = (row) => {
    application
      .post(operationURLS.delete, {
        id: [row.id],
      })
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
          pagename: pageName,
          status: response.data.status,
        });
      });

    setConfirmDelete(false);
  };

  const onCancel = () => {
    setSelectedRow([]);
    setSelectedRowData([]);
    setSelectedLocation([]);
    setConfirmDelete(false);
  };

  function onSaveForm(data) {
    application
      .post(operationURLS.register, data)
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: pageName,
        });
      });
    setOpenForm(false);
  }

  function onCloseForm() {
    setOpenForm(false);
  }
  function handleCloseSelect() {
    setOpenSelect(false);
    setSelectedCategory("");
  }

  function create() {
    if (!selectedRowData || selectedRowData.length === 0 && !selectedCategory) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: pageName,
      });
      return;
    }
    if (!selectedCategory) {
      setNotify({
        isOpen: true,
        status: "First Please select Category",
        type: "warning",
        pagename: pageName,
      });
      return;
    }
    const ipAddresses = selectedRowData.map((item) => item.ipAddress);
    const locations = selectedRowData.map((item) => item.location);
    const data = {
      ipAddress: ipAddresses,
      location: locations,
      category: selectedCategory,
    };
    application
      .post("/discoverIp/create", data)
      .then((response) => {
        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
        setOpenSelect(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: pageName,
        });
      });
  }
  function onRowSelectionChange(row) {
    setSelectedRowData(row);
  }
  function handleUpdateList() {
    setUpdateList(Date.now());
  }
  return (
    <MDBox>
      <DeleteConfirmation
        entityName="Discovered IP"
        data={selectedRow}
        columns={getColumns(deleteRow, editRow)}
        confirmDelete={confirmDelete}
        onAgree={onAgree}
        onCancel={onCancel}
      />
      <CTLBaseDialogForm
        entityName="Discovered IP"
        columns={getColumns(deleteRow, editRow)}
        openForm={openForm}
        onSaveForm={onSaveForm}
        onCloseForm={onCloseForm}
        formData={formData}
        pageAttributes={Attributes}
      />

      <CTLTable
        apiURL={operationURLS.list}
        advancedFilters={advancedFilters}
        onRowSelectionChange={onRowSelectionChange}
        columns={getColumns(deleteRow, editRow, handleUpdateList)}
        entriesPerPage={false}
        canSearch
        defaultSortDirection="desc"
        defaultSortColumn="discoveryTime"
        pageId={pageId}
        searchText={searchText}
        hasRowSelection={true}
        updateList={updateList}
      />
      <CTLAdvancedFilter
        entityName="Discovered IP"
        advancedFilters={advancedFilters}
        columns={getColumns(deleteRow, editRow)}
        applyFilter={openFilter}
        onApplyFilter={onApplyFilter}
        onCloseFilter={onCloseFilter}
      />
      <Box>
        <Dialog
          maxWidth="sm"
          open={openSelect}
          onClose={handleCloseSelect}
          sx={{
            "& .MuiDialog-container": {
              alignItems: "flex-start",
            },
            "& .MuiPaper-root": {
              marginTop: "100px",
              borderRadius: "10px",
            },
          }}
        >
          <DialogContent
            sx={{
              backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "20rem",
              padding: "10px",
              gap: ".7em",
            }}
          >
            <Box width="100%" sx={{ paddingBottom: "50px" }}>
              <Box width="100%" display="flex" justifyContent="center">
                <MDTypography variant="button" fontWeight="bold" gutterBottom>
                  Select Category
                </MDTypography>
              </Box>
              <Box width="100%">
                <select
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "1rem",
                  }}
                  value={selectedCategory || ""}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {Array.isArray(categoryOptions) &&
                    categoryOptions.map((category) => (
                      <option
                        key={category?.categoryCode}
                        value={category?.categoryCode}
                      >
                        {category?.categoryName}
                      </option>
                    ))}
                </select>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{ backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF" }}
          >
            <MDBox display="flex" gap={2}>
              <MDButton
                variant="gradient"
                color="error"
                size="small"
                onClick={handleCloseSelect}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="success"
                size="small"
                onClick={create}
              >
                Submit
              </MDButton>
            </MDBox>
          </DialogActions>
        </Dialog>
      </Box>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default DiscoveredIP;
